import React from 'react';
import {Grid} from '@material-ui/core'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting';

// Inicializar o módulo de exportação do Highcharts
HC_exporting(Highcharts);

const BasicColumnChart = (props) => {
    const containerRef = React.useRef(null);

    const options = {
        chart: {
            type: 'column'
        },
        title: {
            text: 'Cenário Municipal do FIA'
        },
        xAxis: {
            categories: [
                'Municípios sem doações do IR',
                'Municípios com registro/cadastro de dados inconsistente ou incompleto na SNDCA/MDH',
                'Municípios que receberam repasse de doações do IR',
                'Municípios que não possuem cadastro na SNDCA/MDH'
            ]
        },
        yAxis: {
            title: {
                text: 'Quantidade de Municipios'
            }
        },
        series: [
        //     {
        //     name: '2017',
        //     data: [321, 1010, 1191, 3046]
        // }, {
        //     name: '2018',
        //     data: [347, 699, 1355, 3167]
        // },
         {
            name: '2020',
            data: [3821, 1640, 1747, 2181]
        }, {
            name: '2021',
            data: [3469, 1495, 2099, 1974]
        }, {
            name: '2022',
            data: [2932, 789, 2636, 2143]
        }, {
            name: '2023',
            data: [2686, 807, 2882, 1879]
        }],
        exporting: {
            enabled: true,
            buttons: {
                contextButton: {
                    symbol: 'menu',
                    symbolStrokeWidth: 1,
                    symbolSize: 18
                }
            }
        },
        credits: {
            enabled: false
        }
    };

    return (
        <Grid container>

            <Grid {...props.containerProps} ref={containerRef} />
            <HighchartsReact highcharts={Highcharts} options={options} containerProps={props.containerProps} ref={containerRef} />
        </Grid>
    );
}

export default BasicColumnChart;
